import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import cookie from "react-cookies";
import queryString from "query-string";

import { INSURANCE_REGISTER, INSURANCE_TNDS } from "../../constant/routes";

import Header from "../components/header";
import Footer from "../components/footer";

import bg_ins from "../../static/images/insurance-page/home/banner-home.png";
import bg_ins1 from "../../static/images/insurance-page/home/ins-type-bg.png";
import ins_tnds from "../../static/images/insurance-page/home/tnds-ins.svg";
import ins_explain from "../../static/images/insurance-page/home/explain-ins.svg";
import ins_gc from "../../static/images/landingpage/ins-partner/global-care.jpg";
import ins_mic from "../../static/images/landingpage/ins-partner/mic.jpg";
import ins_pjico from "../../static/images/landingpage/ins-partner/pjico.png";
import ins_pti from "../../static/images/landingpage/ins-partner/pti.png";

import ins_feature_1 from "../../static/images/insurance-page/home/ins-feature-1.png";
import ins_feature_2 from "../../static/images/insurance-page/home/ins-feature-2.png";
import ins_feature_3 from "../../static/images/insurance-page/home/ins-feature-3.png";
import ins_feature_4 from "../../static/images/insurance-page/home/ins-feature-4.png";

import ins_process_1 from "../../static/images/insurance-page/home/process1.svg";
import ins_process_2 from "../../static/images/insurance-page/home/process2.svg";
import ins_process_3 from "../../static/images/insurance-page/home/process3.svg";
import ins_process_4 from "../../static/images/insurance-page/home/process4.svg";

const INS_PARTNER = [
	{
		id: "ins_gc",
		img: ins_gc,
		alt: "Bảo hiểm xe ô tô Global Care",
	},
	{
		id: "ins_mic",
		img: ins_mic,
		alt: "Bảo hiểm xe ô tô MIC",
	},
	{
		id: "ins_pjico",
		img: ins_pjico,
		alt: "Bảo hiểm xe ô tô PJICO",
	},
	{
		id: "ins_pti",
		img: ins_pti,
		alt: "Bảo hiểm xe ô tô PTI",
	},
];

const INS_FEATURES = [
	{
		id: "ins_feature_1",
		img: ins_feature_1,
		alt: "Tiết kiệm hơn giá thị trường",
	},
	{
		id: "ins_feature_2",
		img: ins_feature_2,
		alt: "Sản phẩm bảo hiểm uy tín",
	},
	{
		id: "ins_feature_3",
		img: ins_feature_3,
		alt: "Thủ tục đăng ký nhanh chóng",
	},
	{
		id: "ins_feature_4",
		img: ins_feature_4,
		alt: "Nhiều ưu đãi từ Mioto",
	},
];

const INS_PROCESS = [
	{
		id: "ins_process_1",
		img: ins_process_1,
		alt: "Quy trình mua bảo hiểm ô tô",
		desc: `1. Khách gửi yêu cầu và được Mioto tư&nbsp;vấn.`,
	},
	{
		id: "ins_process_2",
		img: ins_process_2,
		alt: "Biểu phí bảo hiểm xe ô tô",
		desc: `2. Thanh&nbsp;toán`,
	},
	{
		id: "ins_process_3",
		img: ins_process_3,
		alt: "Bảo hiểm 2 chiều xe ô tô",
		desc: `3. Mioto gửi <strong>Giấy chứng nhận bảo hiểm </strong>qua email đến chủ xe trong vòng <strong>1 ngày </strong>kể từ thời điểm thanh&nbsp;toán.`,
	},
	{
		id: "ins_process_4",
		img: ins_process_4,
		alt: "Bảo hiểm bắt buộc ô tô",
		desc: `4. Mioto gửi <strong>Giấy chứng nhận bảo hiểm </strong>(bản cứng) đến chủ xe trong vòng <strong>2-3 ngày </strong>làm&nbsp;việc.`,
	},
];

const InsuranceBanner = () => {
	return (
		<div className="ins-banner-section" style={{ backgroundImage: `url(${bg_ins})` }}>
			<div className="m-container">
				<div className="content-container">
					<h1>Mua Bảo Hiểm Xe Ô Tô Online</h1>
					<h2 className="text-primary">Phí Tốt Nhất Cùng MIOTO!</h2>
					<h4>Chọn sản phẩm bảo hiểm bạn muốn mua</h4>
					<div className="ins-type-wrap">
						<Link
							to={INSURANCE_TNDS}
							className="ins-type"
							style={{
								backgroundImage: `url(${bg_ins1})`,
							}}>
							<img loading="lazy" src={ins_tnds} />
							<p>BẢO HIỂM TNDS BẮT&nbsp;BUỘC</p>
						</Link>
						<Link
							to={INSURANCE_REGISTER}
							className="ins-type"
							style={{
								backgroundImage: `url(${bg_ins1})`,
							}}>
							<img loading="lazy" src={ins_explain} />
							<p>BẢO HIỂM VẬT CHẤT XE Ô&nbsp;TÔ</p>
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
};

const InsurancePartner = () => {
	return (
		<div className="ins-partner-section space sec">
			<div className="m-container">
				<h4>Đối Tác Bảo Hiểm</h4>
				<Swiper
					className="swiper-insurance"
					modules={[Pagination]}
					spaceBetween={10}
					pagination={{
						el: ".pagi-insurance",
						dynamicBullets: true,
						clickable: true,
					}}
					breakpoints={{
						992: {
							slidesPerView: 3,
							spaceBetween: 40,
						},
						768: {
							slidesPerView: 2,
							spaceBetween: 20,
						},
					}}>
					{INS_PARTNER.map((ins) => (
						<SwiperSlide key={ins.id}>
							<img loading="lazy" src={ins.img} alt={ins.alt} />
						</SwiperSlide>
					))}
					<div className="swiper-pagination pagi-insurance" />
				</Swiper>
			</div>
		</div>
	);
};

const InsuranceFeature = () => {
	return (
		<div className="ins-feature-section space sec">
			<div className="m-container">
				<h4>Tính Năng Nổi Bật</h4>
				<Swiper
					modules={[Pagination]}
					className="swiper-insurance-feature"
					slidesPerView={1.3}
					spaceBetween={15}
					pagination={{
						el: ".pagi-ins-ft",
						clickable: true,
						dynamicBullets: true,
					}}
					breakpoints={{
						1200: {
							slidesPerView: 4,
						},
						992: {
							slidesPerView: 3.2,
						},
						768: {
							slidesPerView: 2.5,
						},
						577: {
							slidesPerView: 2,
						},
					}}>
					{INS_FEATURES.map((ins) => (
						<SwiperSlide key={ins.id}>
							<img loading="lazy" src={ins.img} alt={ins.alt} />
						</SwiperSlide>
					))}
					<div className="swiper-pagination pagi-ins-ft" />
				</Swiper>
			</div>
		</div>
	);
};

export const InsuranceProcess = () => (
	<div className="ins-process-section bg-white space sec">
		<div className="m-container">
			<h4>Quy Trình Cấp Giấy Chứng Nhận Bảo Hiểm</h4>
			<div className="ins-process-wrap">
				{INS_PROCESS.map((ins) => (
					<div className="ins-process" key={ins.id}>
						<img loading="lazy" src={ins.img} alt={ins.alt} />
						<p dangerouslySetInnerHTML={{ __html: ins.desc }} />
					</div>
				))}
			</div>
		</div>
	</div>
);

const InsuranceHome = (props) => {
	useEffect(() => {
		if (props.location && props.location.search) {
			const query = queryString.parse(props.location.search);

			if (query.utm_source) {
				cookie.save("_utm_src", query.utm_source, { path: "/" });
				cookie.save("_utm_src", query.utm_source, { path: "/", domain: ".mioto.vn" });
			}
			if (query.utm_ext) {
				cookie.save("_utm_ext", query.utm_ext, { path: "/" });
				cookie.save("_utm_ext", query.utm_ext, { path: "/", domain: ".mioto.vn" });
			} else {
				cookie.remove("_utm_ext", { path: "/" });
				cookie.remove("_utm_ext", { path: "/", domain: ".mioto.vn" });
			}
		}
	}, []);

	return (
		<div className="mioto-layout">
			<Header />
			<Helmet>
				<title>BẢO HIỂM XE Ô TÔ ONLINE | MIOTO</title>
				<meta
					name="description"
					content={`Tham gia bảo hiểm ô tô toàn diện bao gồm bảo hiểm vật chất xe ô tô, bảo hiểm dân sự bắt buộc, bảo hiểm ô tô hai chiều, bảo hiểm thân vỏ, bảo hiểm dân sự hàng hóa... để hưởng trọn vẹn quyền lợi bảo hiểm ô tô`}
				/>
				<meta content={`Bảo hiểm thân vỏ, bảo hiểm trách nhiệm, bảo hiểm xe ô tô`} property="og:title"></meta>
			</Helmet>
			<section className="body">
				<div className="insurance-home">
					<InsuranceBanner />
					<InsurancePartner />
					<InsuranceFeature />
					<InsuranceProcess />
				</div>
			</section>
			<Footer />
		</div>
	);
};

export default InsuranceHome;
